// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AboutUs_image-content__7lV53 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  text-align: left;
}

.AboutUs_image-content__7lV53::after {
  content: "";
  background: rgba(45, 88, 35, 0.7);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.65) 19.38%, rgba(0, 0, 0, 0.3) 52.15%, rgba(0, 0, 0, 0.05) 88.61%);
}

.AboutUs_image-text__kh11x {
  position: relative;
  font-size: 24px;
  font-weight: bold;
  z-index: 1;
  color: #ffffff;
  margin: auto auto;
  width: 80%;
}

.AboutUs_about-us-content__JyDuA {
  font-size: 20px;
  text-align: left;
  margin-bottom: 80px;
}`, "",{"version":3,"sources":["webpack://./src/views/AboutUs/AboutUs.module.scss","webpack://./src/styles/_typography.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AAFF;;AAKA;EACE,WAAA;EACA,iCAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sHAAA;AAFF;;AAUA;EACE,kBAAA;EACA,eCxBS;EDyBT,iBCvBK;EDwBL,UAAA;EACA,cEvBM;EFwBN,iBAAA;EACA,UAAA;AAPF;;AAUA;EACE,eClCS;EDmCT,gBAAA;EACA,mBAAA;AAPF","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.image-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n  text-align: left;\n}\n\n.image-content::after {\n  content: \"\";\n  background: rgba(45, 88, 35, 0.7);\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(\n    180deg,\n    rgba(0, 0, 0, 0.65) 19.38%,\n    rgba(0, 0, 0, 0.3) 52.15%,\n    rgba(0, 0, 0, 0.05) 88.61%\n  );\n}\n\n.image-text {\n  position: relative;\n  font-size: typography.$header-m;\n  font-weight: typography.$bold;\n  z-index: 1;\n  color: colors.$white;\n  margin: auto auto;\n  width: 80%;\n}\n\n.about-us-content {\n  font-size: typography.$header-s;\n  text-align: left;\n  margin-bottom: 80px;\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image-content": `AboutUs_image-content__7lV53`,
	"image-text": `AboutUs_image-text__kh11x`,
	"about-us-content": `AboutUs_about-us-content__JyDuA`
};
export default ___CSS_LOADER_EXPORT___;
